import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, ArrowRight, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { blogPosts } from './blog/posts';
export function BlogPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Blog | IntelliEats';
    // Google AdSense - inject into <head>
    if (!document.querySelector('script[src*="adsbygoogle"]')) {
      const adsScript = document.createElement('script');
      adsScript.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3041826185319356';
      adsScript.async = true;
      adsScript.setAttribute('crossorigin', 'anonymous');
      document.head.appendChild(adsScript);
    }
  }, []);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="pt-32 pb-24 bg-white min-h-screen" data-id="element-1988" data-mp="aus31o269s5j">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1989" data-mp="ft3do10ak6ot">
        {/* Header */}
        <header className="mb-12 text-center" data-id="element-1990" data-mp="orkpsp5rdjqt">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-brand-600 hover:text-brand-700 mb-8 transition-colors" data-id="element-1991" data-mp="jtssffmch5f8">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-1992" data-mp="xna6wm06brye" />
            Back to Home
          </Link>
          <h1 className="text-4xl sm:text-5xl font-black text-slate-900 tracking-tight leading-tight mb-4" data-id="element-1993" data-mp="tkdujd188s2w">
            The IntelliEats Blog
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-1994" data-mp="vou7g7zwqs7">
            Insights, guides, and tips to help you understand what's really in
            your food and make smarter choices.
          </p>
        </header>

        {/* Post List */}
        <div className="space-y-8" data-id="element-1995" data-mp="9xppi7jo52r8">
          {blogPosts.map((post, index) => <motion.div key={post.slug} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-1996" data-mp="1q80cy71gu9xc" data-mpi={index}>
              <Link to={`/blog/${post.slug}`} className="group block bg-white rounded-3xl border border-slate-100 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 overflow-hidden" data-id="element-1997" data-mp="rxsgbj6fj94k">
                <div className="grid sm:grid-cols-5 gap-0" data-id="element-1998" data-mp="51f0u9w2u8g">
                  <div className="sm:col-span-2 relative overflow-hidden" data-id="element-1999" data-mp="4999l83134el">
                    <img src={post.image} alt={post.imageAlt} className="w-full h-48 sm:h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-2000" data-mp="97ap5j18wllb" />
                    <span aria-hidden="true" className="pointer-events-none absolute bottom-2 right-2 select-none rounded-full bg-white/70 px-2 py-0.5 text-[10px] font-black tracking-tight backdrop-blur-sm" data-id="element-2001" data-mp="3cm6pfqu4nd3i">
                      <span className="text-slate-900/70" data-id="element-2002" data-mp="3559w257tjeov">Intelli</span>
                      <span className="text-brand-600/80" data-id="element-2003" data-mp="304vwlbka9d2g">Eats</span>
                    </span>
                  </div>
                  <div className="sm:col-span-3 p-6 sm:p-8 flex flex-col justify-center" data-id="element-2004" data-mp="2w3acb55f5wi8">
                    <div className="flex items-center gap-3 mb-3" data-id="element-2005" data-mp="2r60pzydbu0ym">
                      <span className="px-3 py-1 rounded-full bg-brand-50 text-brand-700 text-xs font-bold tracking-wider uppercase" data-id="element-2006" data-mp="2meip1abb00dn">
                        {post.category}
                      </span>
                      <span className="flex items-center text-xs text-slate-400" data-id="element-2007" data-mp="2cgcmqrll4s89">
                        <Clock className="w-3 h-3 mr-1" data-id="element-2008" data-mp="28ehpby6ryyzr" />
                        {post.readTime}
                      </span>
                    </div>
                    <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-3 leading-snug group-hover:text-brand-700 transition-colors" data-id="element-2009" data-mp="23gplc5suvmf7">
                      {post.title}
                    </h2>
                    <p className="text-slate-600 text-sm leading-relaxed mb-4 line-clamp-3" data-id="element-2010" data-mp="bdbutmozl2nf">
                      {post.excerpt}
                    </p>
                    <span className="inline-flex items-center text-sm font-semibold text-brand-600 group-hover:text-brand-700" data-id="element-2011" data-mp="2l9z21pv4ajh">
                      Read Article
                      <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-2012" data-mp="3jvrii02aqrm6" />
                    </span>
                  </div>
                </div>
              </Link>
            </motion.div>)}
        </div>
      </div>
    </motion.div>;
}